module.exports = __webpack_public_path__ + "img/check-double.44135456.svg";